import { Header } from "components/atoms/Typography";
import { IncreaseDecreasePercentage } from "components/molecules/Card/CardFunctions";
import { DataSection, ValueType } from "components/molecules/Card/CardTypes";
import errorFallbackUI from "components/molecules/ErrorFallbackUI.tsx/ErrorFallbackUI";
import { ComponentErrorBoundary } from "components/molecules/ErrorStates";
import { displayValueWithUnit, getDisplayInfo } from "utils/formatting";
import { CapitalSections } from "../CapitalCard.helper";
import "../CapitalCard.scss";

interface CapitalSummaryProps {
    section: CapitalSections;
    cardHeaderData: DataSection;
}

function CapitalSummary({ section, cardHeaderData }: CapitalSummaryProps) {
    const capitalHeaderData = cardHeaderData.find((item) => item.key === section);
    if (!capitalHeaderData) return null;

    const { value, displayInfoKey, valueColor } = capitalHeaderData;

    const { unit, formatFunction } =
        typeof value === "number" ? getDisplayInfo(displayInfoKey, value) : getDisplayInfo(displayInfoKey);

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            <ComponentErrorBoundary fallback={errorFallbackUI("cardHeaderError")} originComponent="Card">
                <Header>{section}</Header>
                <div className="card__value-and-percentage">
                    <Header style={{ color: valueColor }}>
                        {displayValueWithUnit(
                            capitalHeaderData.value,
                            unit,
                            (v: ValueType) => formatFunction(v) ?? String(v)
                        )}
                    </Header>
                    {typeof capitalHeaderData.increaseDecreasePercentage === "number" && (
                        <IncreaseDecreasePercentage
                            isHeader={true}
                            value={capitalHeaderData.increaseDecreasePercentage}
                            tooltipElement={capitalHeaderData.tooltipElement}
                            invertedColor={capitalHeaderData.invertedColor}
                        />
                    )}
                </div>
            </ComponentErrorBoundary>
        </div>
    );
}

export default CapitalSummary;
